export default __webpack_public_path__ + "static/media/QuickCamIcon.6e98cd62.svg";